__turbopack_context__.v({
  "link": "NavLink-module-scss-module__KQvu6q__link",
});
